module.exports = "/_next/static/media/safari-icon.e4108f67.png";